// Join-request intake forms — the canonical shapes shared by the server
// (jsonb column `$type`, validation, DSR/retention) and the web client
// (builder, renderer, review). See
// docs/design/network-member-request-upgrade/data-and-api-contracts.md.
//
// A Circle has one form (`member_to_circle`); a Network has two independent
// forms (`member_to_network`, `circle_to_network`). Forms are versioned; a
// submitted answer snapshot pins the version it was answered against and
// copies the question wording AS ASKED so a later form edit never
// reinterprets an old answer.
export const INTAKE_FORM_KINDS = [
    'member_to_circle',
    'member_to_network',
    'circle_to_network',
];
export function isIntakeTombstone(r) {
    return 'scrubbed' in r;
}
// ---------------------------------------------------------------------------
// Server-enforced caps (also reflected client-side). See contracts §4.
// ---------------------------------------------------------------------------
export const MAX_QUESTIONS = 8;
export const MAX_PROMPT_CHARS = 200;
export const MAX_ANSWER_CHARS = 1000;
/** Total serialized `intake` payload ceiling — under the WAF 8 KB body block. */
export const MAX_INTAKE_BYTES = 6144;
export const MIN_CHOICE_OPTIONS = 2;
export const MAX_CHOICE_OPTIONS = 10;
export const MAX_CHOICE_OPTION_CHARS = 120;
// ---------------------------------------------------------------------------
// Consent wiring for intake submissions (D2). `policyVersion` is a placeholder
// until Legal finalizes the statement copy (D-DEF-3).
// ---------------------------------------------------------------------------
export const INTAKE_CONSENT_PURPOSE = 'intake_answer_sharing';
export const INTAKE_CONSENT_SOURCE = 'intake';
export const INTAKE_CONSENT_POLICY_VERSION = 'intake-consent-v1';
// The two fixed consent statements' stable keys (copy resolved via i18n /
// legal, not stored here).
export const INTAKE_CONSENT_STATEMENT_KEYS = ['share_with_leaders', 'withdraw_right'];
//# sourceMappingURL=intake.js.map